import React from 'react';
import Logo from '../Logo/Logo'
import DocumentTitle from '../DocumentTitle/DocumentTitle';
import MyHeader from "./Header.module.css";
import { ShareModal } from '../ShareModal/ShareModal';
import HeaderAvatar from '../Avatar/HeaderAvatar';
import { Present } from '../Present/Present';
import Navigations from "../Navigations/Navigations";
import { useSelector } from 'react-redux';
import { FileDropdown } from '../Navigations/FileDropdown/FileDropdown';
import DocumentMembers from '../Members/members';
import AppLauncherModal from '../AppLauncher/AppLauncherModal';
import Modes from './modes.js'
import PrintSlide from '../Print/printSlide.js';
import CompleteDocument from '../CompleteDoc/completeDoc.js';
import SavingStatus from '../SavingStatus/savingStatus .js';
import TemplateThumbnail from '../TemplateThumbnail/templateThumbnail.js';
import TemplateActiveToggle from '../TemplateToggle/TemplateActiveToggle.js';


export const Header = () => {
    const slides = useSelector(state => state.slide.slides);
    const documentInformation = useSelector((state) => state.slide.documentInformation);
    const userInformation = useSelector((state) => state.slide.userInformation);
    const isReadOnly = useSelector((state) => state.slide.isReadOnly);
    const isTemplateDocument = useSelector((state) => state.slide.isTemplateDocument);
    return (
        <div className={MyHeader.headerMain} id='my-header'>
            <Logo />
            {/* <div className={MyHeader.headerCol}> */}
            <div className={MyHeader.headerCol} style={{ flexDirection: 'row', justifyContent: 'flex-start' }}>
                <DocumentTitle />
                <PrintSlide />
                {
                    !isTemplateDocument && !isReadOnly && <CompleteDocument />
                }
                {!isTemplateDocument && <SavingStatus />}
                {/* <Navigations/>  */}
                {/* <FileDropdown /> */}
            </div>
            {/* </div> */}
            <div className={MyHeader.titleBarButtons}>
                {!isTemplateDocument && <DocumentMembers />}
                {slides && <Present />}
                {documentInformation.createBy == userInformation.userId && !isTemplateDocument && (
                    <>
                        <ShareModal />
                    </>
                )}
                {isTemplateDocument && <TemplateActiveToggle />}
                {isTemplateDocument && <TemplateThumbnail />}
                <AppLauncherModal scale={0.8} />
                <Modes />
                <HeaderAvatar scale={0.8} />
            </div>
        </div>

    )
};


